// extracted by mini-css-extract-plugin
export default {"popoverContent":"index_popoverContent__PDFBC","actionButton":"index_actionButton__3BMrh"};